import React from "react";
import Slider from "react-slick";
import "./Home.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FreightSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 420,
    cssEase: "ease-out",
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: true,
    swipe: true,
    swipeToSlide: true,
    touchMove: true,
    draggable: true,
    touchThreshold: 10,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 6 },
      },
      {
        breakpoint: 1100,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
          centerMode: true,
          centerPadding: "34px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  const data = [
    {
      number: "1",
      title: "High Speed Gateway",
      description: "Send SMS instantly with our high speed gateway.",
    },
    {
      number: "2",
      title: "Real Time Reports",
      description: "Get detailed delivery reports and analytics in real-time.",
    },
    {
      number: "3",
      title: "Developer API",
      description: "API is readily available for all platforms development.",
    },
    {
      number: "4",
      title: "Unlimited Sender ID",
      description: "Activates sender ID as per your requirement.",
    },
    {
      number: "5",
      title: "User Friendly Interface",
      description: "Our services from our easy &  user friendly website.",
    },
    {
      number: "6",
      title: "DND/DNC Filtering",
      description: "Compliant filtering for DND and DNC numbers.",
    },
    {
      number: "7",
      title: "Data Security & Privacy",
      description: "Your data is protected with enterprise-grade security.",
    },
    {
      number: "8",
      title: "Excellent Support",
      description: "24/7 customer support for all your business needs.",
    },
  ];

  return (
    <section className="freight-area">
      <div className="freight-container">
        <div className="freight-header">
          <span className="sub-title">Features </span>
          <h2>Best Bulk SMS Service Provider in India</h2>
          <p>
            Finding the <b>Best Bulk SMS Service Provider in India</b> is important for
            companies that <br /> need dependable SMS delivery and low pricing. The
            Best Bulk SMS Service Provider in  India<br />  offers  a fast SMS gateway, a
            high delivery rate, DLT registration support,<br /> and 24/7 customer
            service.
          </p>
          <p> <b>Features of Best Bulk SMS Service Provider</b> :</p>
        </div>

        <Slider {...settings}>
          {data.map((item, index) => (
            <div key={index} className="freight-card">
              <article className="freight-card-inner" aria-label={item.title}>
                <div className="freight-number" aria-hidden="true">
                  {item.number}
                </div>
                <div className="freight-info">
                  <h4 className="freight-tag">{item.title}</h4>
                  <p className="freight-description">{item.description}</p>
                </div>
              </article>
            </div>
          ))}
        </Slider>

        <div className="freight-mobile-strip" aria-label="Freight features">
          {data.map((item) => (
            <article className="freight-card freight-card-mobile" key={item.number} aria-label={item.title}>
              <div className="freight-card-inner">
                <div className="freight-number" aria-hidden="true">
                  {item.number}
                </div>
                <div className="freight-info">
                  <h4 className="freight-tag">{item.title}</h4>
                  <p className="freight-description">{item.description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FreightSlider;
